<!-- ═══ HESAP SECİM / ERİŞİM YOK EKRANI ═══ -->
@if (!seciliHesap()) {
  <div class="hp-hesap-ekran">
    <div style="display:flex;align-items:center;padding:6px 10px 0;min-width:0;">
      <button class="ui basic mini icon button" style="margin-right:8px;flex-shrink:0;" (click)="geriDon()">
        <i class="arrow left icon"></i>
      </button>
      <nz-divider nzText="📧 Posta Kutuları"
                  nzOrientation="center"
                  style="margin:0;flex:1;min-width:0;overflow:hidden;"
                  nzSize="small"></nz-divider>
      <button class="ui basic mini icon button" style="margin-left:8px;flex-shrink:0;" (click)="hesaplariYukle()">
        <i class="redo icon"></i>
      </button>
    </div>

    @if (yukleniyor()) {
      <div class="hp-merkez"><nz-spin nzSimple></nz-spin></div>
    } @else if (hata()) {
      <div class="hp-merkez">
        <span nz-icon nzType="warning" nzTheme="outline" style="font-size:48px;color:#faad14;margin-bottom:12px"></span>
        <p style="color:#8c8c8c;margin:0">Bağlantı hatası. Tekrar deneyin.</p>
      </div>
    } @else if (hesaplar().length === 0) {
      <div class="hp-merkez">
        <span nz-icon nzType="lock" nzTheme="outline" style="font-size:48px;color:#d9d9d9;margin-bottom:12px"></span>
        <p style="color:#8c8c8c;margin:0;text-align:center">Erişebileceğiniz mail hesabı bulunamadı</p>
      </div>
    } @else {
      <div class="hp-hesap-grid">
        @for (h of hesaplar(); track h._id) {
          <div class="hp-kare-kart" (click)="hesapSec(h)">
            <div class="hp-kare-avatar" [style.background]="avatarRenk(h.email)">
              {{ avatarHarf(h.email) }}
            </div>
            <span class="hp-kare-email">{{ h.email }}</span>
            <span class="hp-kare-aciklama">
              @if (h.okunmamisSayisi) {
                {{ h.okunmamisSayisi }} okunmamış
              } @else {
                Gelen kutusu
              }
            </span>
            @if (h.okunmamisSayisi) {
              <nz-badge [nzCount]="h.okunmamisSayisi" [nzOverflowCount]="99" class="hp-kare-badge"></nz-badge>
            }
          </div>
        }
      </div>
    }
  </div>
}

<!-- ═══ POSTA EKRANI (liste + detay split) ═══ -->
@if (seciliHesap()) {
  <div class="hp-root" [class.hp-detay-acik]="!!seciliMail()">

    <!-- Sol: Mail Listesi -->
    <div class="hp-liste-panel">
      <div style="display:flex;align-items:center;padding:6px 10px 0;min-width:0;">
        <button class="ui basic mini icon button" style="margin-right:8px;flex-shrink:0;" (click)="geriDon()">
          <i class="arrow left icon"></i>
        </button>
        <nz-divider [nzText]="'📧 ' + seciliHesap()?.email"
                    nzOrientation="center"
                    style="margin:0;flex:1;min-width:0;overflow:hidden;"
                    nzSize="small"></nz-divider>
        <button class="ui basic mini icon button" style="margin-left:8px;flex-shrink:0;" (click)="mailleriYukle()">
          <i class="redo icon"></i>
        </button>
      </div>

      <!-- Arama -->
      <div class="hp-arama-kutu" [class.hp-arama-acik]="aramaAcik">
        <div class="hp-arama-ust">
          <span nz-icon nzType="search" nzTheme="outline"></span>
          <input class="hp-arama-input" placeholder="Mail ara..."
            [value]="aramaMetni()"
            (focus)="aramaAcik = true; cd.detectChanges();"
            (input)="aramaGirdisi($any($event.target).value)" />
          @if (aramaMetni()) {
            <button class="hp-arama-temizle" (click)="aramayiTemizle()">
              <span nz-icon nzType="close-circle" nzTheme="fill"></span>
            </button>
          }
        </div>
        @if (aramaAcik) {
          <div class="hp-arama-panel" (mousedown)="$event.preventDefault()">
            <div class="hp-arama-panel-ust">
              <div class="hp-arama-etiketler">
                <span class="hp-arama-etiket" [class.aktif]="aramaAlanlari.konu" (click)="aramaAlaniToggle('konu')">Konu</span>
                <span class="hp-arama-etiket" [class.aktif]="aramaAlanlari.gonderen" (click)="aramaAlaniToggle('gonderen')">Gönderen</span>
                <span class="hp-arama-etiket" [class.aktif]="aramaAlanlari.icerik" (click)="aramaAlaniToggle('icerik')">İçerik</span>
                <span class="hp-arama-etiket" [class.aktif]="aramaAlanlari.dosya" (click)="aramaAlaniToggle('dosya')">Dosyalar</span>
              </div>
              <button class="hp-arama-panel-kapat" (click)="aramaAcik = false; cd.detectChanges();" title="Kapat">
                <span nz-icon nzType="up" nzTheme="outline"></span>
              </button>
            </div>
            <div class="hp-arama-bilgi">
              {{ toplamMail() }} mail
              @if (aramaMetni() && filtrelenmisMailler().length !== toplamMail()) {
                · {{ filtrelenmisMailler().length }} sonuç
              }
            </div>
          </div>
        }
      </div>

      @if (yukleniyor()) {
        <div class="hp-merkez"><nz-spin nzSimple></nz-spin></div>
      } @else if (hata()) {
        <div class="hp-merkez">
          <span nz-icon nzType="warning" nzTheme="outline" style="font-size:36px;color:#faad14;margin-bottom:8px"></span>
          <p style="color:#8c8c8c;margin:0;font-size:12px">Yükleme hatası. Tekrar deneyin.</p>
        </div>
      } @else if (filtrelenmisMailler().length === 0) {
        <nz-empty nzNotFoundContent="Mail bulunamadı" style="padding:40px 0"></nz-empty>
      } @else {
        <div class="hp-liste">
          @for (mail of filtrelenmisMailler(); track mail._id) {
            <div class="hp-mail-satir" [class.active]="seciliMail()?._id === mail._id"
                 [class.okunmamis]="!mailOkunduMu(mail)" (click)="mailSec(mail)">
              <div class="hp-mail-avatar" [style.background]="avatarRenk(mail.kimden)">
                {{ avatarHarf(mail.kimden) }}
              </div>
              <div class="hp-mail-icerik">
                <div class="hp-mail-ust">
                  <span class="hp-mail-gonderen">{{ gonderenIsim(mail.kimden) }}</span>
                  <span class="hp-mail-tarih">{{ mail.tarih | date:'dd.MM HH:mm' }}</span>
                </div>
                <div class="hp-mail-konu">{{ mimeDecodeIsim(mail.konu) || '(Konu yok)' }}</div>
                <div class="hp-mail-onizleme">{{ snippet(mail) }}</div>
              </div>
              <div class="hp-mail-ikonlar">
                @if (mailYanitlandiMi(mail)) {
                  <span nz-icon nzType="rollback" nzTheme="outline" class="hp-yanit-ikon" nz-tooltip nzTooltipTitle="Yanıtlandı"></span>
                }
                @if (mail.ekler && mail.ekler.length > 0) {
                  <span nz-icon nzType="paper-clip" nzTheme="outline" class="hp-ek-ikon"></span>
                }
              </div>
            </div>
          }
        </div>
        <fikoyt-sayfalama
          [toplam]="toplamMail()"
          [sayfa]="aktifSayfa()"
          [sayfaBoyutu]="MAIL_LIMIT"
          [sayfaBoyutSecenekleri]="[10, 20, 50]"
          [sticky]="false"
          (sayfaDegisti)="sayfaDegisti($event)"
          (sayfaBoyutuDegisti)="sayfaBoyutuDegisti($event)">
        </fikoyt-sayfalama>
      }
    </div>

    <!-- Sag: Mail Detay -->
    <div class="hp-detay-panel">
      @if (seciliMail(); as m) {
        <div class="hp-bar hp-detay-bar">
          <button class="hp-btn-ikon" (click)="seciliMail.set(null)">
            <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
          </button>
          <h3 class="hp-baslik" style="font-size:15px">{{ mimeDecodeIsim(m.konu) || '(Konu yok)' }}</h3>
          @if (silmeYetkisi()) {
            <button class="hp-btn-ikon hp-btn-sil"
                    nz-popconfirm nzPopconfirmTitle="Bu mail silinecek. Emin misiniz?"
                    (nzOnConfirm)="mailSil(m)"
                    nz-tooltip nzTooltipTitle="Sil">
              <span nz-icon nzType="delete" nzTheme="outline"></span>
            </button>
          }
        </div>

        <div class="hp-detay-meta">
          <div class="hp-detay-avatar" [style.background]="avatarRenk(m.kimden)">
            {{ avatarHarf(m.kimden) }}
          </div>
          <div class="hp-detay-info">
            <span class="hp-detay-gonderen">{{ gonderenIsim(m.kimden) }}</span>
            <span class="hp-detay-adres">{{ gonderenAdres(m.kimden) }}</span>
            <span class="hp-detay-tarih">{{ m.tarih | date:'dd MMM yyyy, HH:mm' }}</span>
          </div>
        </div>

        @if (m.ekler && m.ekler.length > 0) {
          <div class="hp-detay-ekler">
            @for (ek of m.ekler; track ek.dosyaAdi) {
              <div class="hp-ek-chip" (click)="ekIndir(ek)">
                <span nz-icon nzType="download" nzTheme="outline"></span>
                {{ mimeDecodeIsim(ek.dosyaAdi) }}
              </div>
            }
          </div>
        }

        <div class="hp-detay-body">
          @if (m.icerikHtml) {
            <div [innerHTML]="guvenliHtml(m.icerikHtml)"></div>
          } @else if (m.icerik) {
            <pre class="hp-detay-text">{{ m.icerik }}</pre>
          } @else {
            <div class="hp-detay-bos">İçerik yükleniyor...</div>
          }
        </div>
      } @else {
        <div class="hp-merkez">
          <span nz-icon nzType="mail" nzTheme="outline" style="font-size:48px;color:#d9d9d9;margin-bottom:12px"></span>
          <p style="color:#8c8c8c;margin:0">Okumak için bir mail seçin</p>
        </div>
      }
    </div>
  </div>
}
